module.exports = __webpack_public_path__ + "img/7_wgoods.e9d418d2.jpg";